import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
const _excluded = ["name", "description", "price", "ddp", "guestCapacity", "availableTickets", "startingTime", "closingTime", "i18n", "isSalesClosed", "onClick", "disabledAction", "isPayAtDoor", "showLeftQuantity", "circleColor", "cursor", "onlinePrice", "offlinePrice", "alignItems", "type", "passValidityFrom", "passValidityUntil", "checkInTimeFrom", "checkInTimeUntil", "isCheckoutMode"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import css from '@styled-system/css';
import propTypes from '@styled-system/prop-types';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
import { Card } from '../Cards';
import { Icon } from '../Icon';
import { PassValidity, Time } from '../Icons';
import { Box, Col, Flex, Row } from '../Layout';
import { SeeMore } from '../SeeMore';
import { TagEndSales, TagOnlyLeft, TagPayAtDoor } from '../Tags';
import { Caption, SecondaryText, TertiaryTitle, Text, TypographyBase } from '../Typography';
const Name = styled(TertiaryTitle).withConfig({
  displayName: "Name",
  componentId: "sc-17wxn8u-0"
})(["&&&{", " width:auto;white-space:pre-wrap;}"], space);
const TagsContainer = styled(Flex).withConfig({
  displayName: "TagsContainer",
  componentId: "sc-17wxn8u-1"
})(["&&&{> div{margin:0 8px;&:first-of-type{margin:0 8px 0 0;}}}"]);
const PriceText = styled(Text).withConfig({
  displayName: "PriceText",
  componentId: "sc-17wxn8u-2"
})(["&&&{margin:0;text-align:right;}"]);
var _StyledPriceText = styled(PriceText).withConfig({
  displayName: "_StyledPriceText",
  componentId: "sc-17wxn8u-3"
})(["", ""], p => p.$_css);
const MessageContainer = styled.div.withConfig({
  displayName: "MessageContainer",
  componentId: "sc-17wxn8u-4"
})(["&&&{display:flex;}"]);
const CircleColor = styled.div.withConfig({
  displayName: "CircleColor",
  componentId: "sc-17wxn8u-5"
})(["width:17px;height:17px;background:", ";border-radius:50%;margin-right:5px;min-width:17px;align-self:center;"], props => props.color);
const CaptionCapitalize = styled(Caption).withConfig({
  displayName: "CaptionCapitalize",
  componentId: "sc-17wxn8u-6"
})(["&:first-letter{text-transform:capitalize;}"]);
const Message = _ref => {
  let {
    msg
  } = _ref;
  return React.createElement(TypographyBase, {
    color: "feeling.negative",
    mr: 1,
    fontStyle: "italic",
    fontSize: 1,
    lineHeight: 2,
    fontWeight: "700"
  }, msg);
};
Message.propTypes = process.env.NODE_ENV !== "production" ? {
  msg: PropTypes.string.isRequired
} : {};
export const Offer = React.forwardRef((props, ref) => {
  const {
      name,
      description,
      price,
      ddp,
      guestCapacity,
      availableTickets,
      startingTime,
      closingTime,
      i18n,
      isSalesClosed,
      onClick,
      disabledAction,
      isPayAtDoor,
      showLeftQuantity,
      circleColor,
      cursor,
      onlinePrice,
      offlinePrice,
      alignItems,
      type,
      passValidityFrom,
      passValidityUntil,
      checkInTimeFrom,
      checkInTimeUntil,
      isCheckoutMode
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const isNotForSale = startingTime && startingTime - moment().unix() > 0;
  const isLast24h = closingTime && closingTime - moment().unix() < 86400;
  const isSalesFinished = closingTime && closingTime - moment().unix() < 0;
  const isSoldOut = availableTickets === 0 || isSalesClosed;
  const isDisabled = !!(isNotForSale || isSalesFinished || isSoldOut);
  const Price = React.createElement(_StyledPriceText, {
    fontWeight: 900,
    color: "text.primaryCardColor",
    fontStyle: isDisabled ? 'italic' : 'inherit',
    $_css: isDisabled && css({
      'text-decoration': 'line-through'
    })
  }, price);
  const Ddp = ddp ? React.createElement(_StyledSecondaryText, _extends({
    color: "text.secondaryCardColor",
    textAlign: "right",
    margin: 0,
    fontStyle: isDisabled ? 'italic' : 'inherit'
  }, props, {
    $_css2: isDisabled && css({
      'text-decoration': 'line-through'
    })
  }), "+ ".concat(ddp, " D.d.p.")) : null;
  const GuestCount = guestCapacity ? React.createElement(SecondaryText, {
    color: "text.secondaryCardColor",
    margin: 0,
    fontStyle: "italic"
  }, guestCapacity) : null;
  const passValidityInitDate = moment.unix(passValidityFrom).format('MMM DD');
  const passValidityEndDate = moment.unix(passValidityUntil).format('ll');
  const checkInTimeInit = moment.unix(checkInTimeFrom).format('hh:mma');
  const checkInTimeEnd = moment.unix(checkInTimeUntil).format('hh:mma');
  const isCheckInTimeEnabled = checkInTimeFrom || checkInTimeUntil;
  const isOnlyLeftTagVisible = showLeftQuantity && !!availableTickets && availableTickets <= 10 && !isSoldOut && !isSalesFinished && !isNotForSale;
  const isClosingTimeTagVisible = closingTime && !isSalesFinished && !isSoldOut && !isNotForSale && isLast24h;
  const isMarginTopCheckInTimeEnabled = (isOnlyLeftTagVisible || isClosingTimeTagVisible) && (isCheckInTimeEnabled || type === 'pass');
  const checkInTime = isCheckInTimeEnabled ? React.createElement(Flex, {
    alignItems: "center"
  }, React.createElement(Flex, {
    alignItems: "center",
    bg: "background.snowPlanet",
    p: "2",
    borderRadius: "6px"
  }, React.createElement(Icon, null, React.createElement(Time, null))), React.createElement(Flex, {
    flexDirection: "column",
    pl: "11px"
  }, React.createElement(Caption, {
    color: "text.secondaryCardColor",
    lineHeight: "1.25"
  }, i18n.entranceValidityTime), React.createElement(CaptionCapitalize, {
    lineHeight: "1.25",
    color: "text.secondaryCardColor",
    fontWeight: "900"
  }, checkInTimeFrom && "".concat(i18n.from, " ").concat(checkInTimeInit, " "), checkInTimeFrom && checkInTimeUntil ? "".concat(i18n.to, " ").concat(checkInTimeEnd) : checkInTimeUntil && "".concat(i18n.until, " ").concat(checkInTimeEnd)))) : null;
  const PassInfo = type === 'pass' ? React.createElement(Flex, {
    alignItems: "center",
    paddingLeft: isCheckInTimeEnabled ? ['30px', '70px'] : []
  }, React.createElement(Flex, {
    alignItems: "center",
    bg: "background.snowPlanet",
    p: "2",
    borderRadius: "6px"
  }, React.createElement(Icon, null, React.createElement(PassValidity, null))), React.createElement(Flex, {
    flexDirection: "column",
    pl: "11px"
  }, React.createElement(Caption, {
    color: "text.secondaryCardColor",
    lineHeight: "1.25"
  }, i18n.passValidity), React.createElement(CaptionCapitalize, {
    lineHeight: "1.25",
    color: "text.secondaryCardColor",
    fontWeight: "900"
  }, "".concat(i18n.from, " ").concat(passValidityInitDate, " ").concat(i18n.until, " ").concat(passValidityEndDate)))) : null;
  const PayAtDoor = isPayAtDoor ? React.createElement(TagPayAtDoor, {
    payAtDoor: i18n.payAtDoor
  }) : null;
  const Downpayment = onlinePrice ? React.createElement(_StyledSecondaryText2, _extends({
    color: "feeling.positive",
    textAlign: "right",
    fontWeight: 900,
    margin: 0,
    fontStyle: isDisabled ? 'italic' : 'inherit'
  }, props, {
    $_css3: isDisabled && css({
      'text-decoration': 'line-through'
    })
  }), i18n.downPayment, " ", onlinePrice) : null;
  const OfflinePrice = offlinePrice ? React.createElement(_StyledSecondaryText3, _extends({
    color: "text.caption",
    textAlign: "right",
    margin: 0,
    fontStyle: isDisabled ? 'italic' : 'inherit'
  }, props, {
    $_css4: isDisabled && css({
      'text-decoration': 'line-through'
    })
  }), "+ ", offlinePrice, " ", i18n.offlinePrice) : null;
  return React.createElement(Card, _extends({
    opacity: isDisabled ? '0.4' : undefined,
    onClick: isDisabled ? disabledAction : onClick,
    paddingX: [2, 3],
    paddingY: 18,
    ref: ref,
    cursor: cursor
  }, rest), React.createElement(Row, {
    alignItems: alignItems || 'center'
  }, React.createElement(Col, {
    flex: 1
  }, React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: ['baseline', 'center', 'center']
  }, React.createElement(Flex, {
    flex: 1,
    flexDirection: ['column', 'inherit'],
    alignItems: ['flex-start', 'center']
  }, React.createElement(Flex, null, circleColor && React.createElement(CircleColor, {
    color: circleColor
  }), React.createElement(Name, {
    color: "text.primaryCardColor",
    wrapped: true
  }, name)), GuestCount), React.createElement(Box, {
    flexDirection: "column",
    width: "auto",
    display: ['flex', 'none']
  }, Price, Ddp, PayAtDoor, Downpayment, OfflinePrice)), React.createElement(MessageContainer, null, isSoldOut ? React.createElement(Message, {
    msg: i18n.soldOut
  }) : React.createElement(React.Fragment, null, isSalesFinished && React.createElement(Message, {
    msg: i18n.salesEnded
  }), isNotForSale && React.createElement(Message, {
    msg: i18n.notForSale
  }))), isCheckoutMode ? React.createElement(Box, {
    my: [1, 1, 2]
  }, React.createElement(SeeMore, {
    color: "text.secondaryCardColor",
    collapsedHeight: 120
  }, description)) : React.createElement(_StyledText, {
    my: [1, 1, 2],
    color: "text.secondaryCardColor"
  }, description), React.createElement(TagsContainer, {
    flexDirection: "row",
    alignItems: "center"
  }, isOnlyLeftTagVisible && React.createElement(TagOnlyLeft, null, i18n.onlyLeft), isClosingTimeTagVisible && React.createElement(TagEndSales, {
    time: closingTime,
    endIn: i18n.endIn
  })), React.createElement(Flex, {
    mt: isMarginTopCheckInTimeEnabled ? [1, 1, 2] : []
  }, checkInTime, PassInfo)), React.createElement(Col, {
    width: "auto",
    display: ['none', 'block']
  }, Price, Ddp, PayAtDoor, Downpayment, OfflinePrice)));
});
Offer.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, propTypes.space), {}, {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  price: PropTypes.string,
  onlinePrice: PropTypes.string,
  startingTime: PropTypes.number.isRequired,
  closingTime: PropTypes.number.isRequired,
  availableTickets: PropTypes.number,
  ddp: PropTypes.string,
  guestCapacity: PropTypes.string,
  isSalesClosed: PropTypes.bool,
  onClick: PropTypes.func,
  disabledAction: PropTypes.func,
  isPayAtDoor: PropTypes.bool,
  circleColor: PropTypes.string,
  cursor: PropTypes.string,
  alignItems: PropTypes.string,
  type: PropTypes.string,
  passValidityFrom: PropTypes.number,
  passValidityUntil: PropTypes.number,
  checkInTimeFrom: PropTypes.number,
  checkInTimeUntil: PropTypes.number,
  i18n: PropTypes.shape({
    soldOut: PropTypes.string,
    salesEnded: PropTypes.string,
    notForSale: PropTypes.string,
    onlyLeft: PropTypes.string,
    endIn: PropTypes.string,
    payAtDoor: PropTypes.string
  }).isRequired,
  showLeftQuantity: PropTypes.bool,
  isCheckoutMode: PropTypes.bool
}) : {};
Offer.defaultProps = {
  availableTickets: null,
  description: '',
  price: 0,
  onlinePrice: 0,
  ddp: null,
  guestCapacity: null,
  isSalesClosed: false,
  onClick: () => {},
  disabledAction: () => {},
  isPayAtDoor: false,
  showLeftQuantity: true,
  cursor: 'pointer',
  circleColor: 'white',
  alignItems: 'center',
  type: 'offer',
  passValidityFrom: null,
  passValidityUntil: null,
  checkInTimeFrom: null,
  checkInTimeUntil: null,
  isCheckoutMode: false
};
var _StyledSecondaryText = styled(SecondaryText).withConfig({
  displayName: "_StyledSecondaryText",
  componentId: "sc-17wxn8u-7"
})(["", ""], p => p.$_css2);
var _StyledSecondaryText2 = styled(SecondaryText).withConfig({
  displayName: "_StyledSecondaryText2",
  componentId: "sc-17wxn8u-8"
})(["", ""], p => p.$_css3);
var _StyledSecondaryText3 = styled(SecondaryText).withConfig({
  displayName: "_StyledSecondaryText3",
  componentId: "sc-17wxn8u-9"
})(["", ""], p => p.$_css4);
var _StyledText = styled(Text).withConfig({
  displayName: "_StyledText",
  componentId: "sc-17wxn8u-10"
})(["white-space:pre-line;overflow-wrap:break-word;"]);